import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-jl",
  "use": "icon-menu-jl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-jl\"><path d=\"M560 552a24 24 0 0 0 24-24V224a24 24 0 0 0-24-24H128a24 24 0 0 0-24 24v304a24 24 0 0 0 24 24h176v72H128C74.984 624 32 581.016 32 528V224c0-53.016 42.984-96 96-96h432c53.016 0 96 42.984 96 96v304c0 53.016-42.984 96-96 96h-56v-72h56z\" p-id=\"79987\" /><path d=\"M584 400h72v72h-72v-72z m-120 72a24 24 0 0 0-24 24v304a24 24 0 0 0 24 24h432a24 24 0 0 0 24-24V496a24 24 0 0 0-24-24H720v-72h176c53.016 0 96 42.984 96 96v304c0 53.016-42.984 96-96 96H464c-53.016 0-96-42.984-96-96V496c0-53.016 42.984-96 96-96h56v72h-56z\" p-id=\"79988\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/menu-jl.svg
// module id = eoAq
// module chunks = 20